module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.matters) ? _c('div', {
    staticClass: "panel-nav"
  }, [_c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.matters), function(m, n) {
    return _c('li', {
      staticClass: "tab-item",
      class: {
        active: _vm.tab === n
      }
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.tab = n
        }
      }
    }, [_vm._v(_vm._s(m.visatype.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matters), function(m, n) {
    return _c('matterdocs', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tab === n),
        expression: "tab === n"
      }],
      key: m.matter._id,
      attrs: {
        "matterdata": m
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dcb1cd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/documents/clientDocs.vue
// module id = 514
// module chunks = 1